import { createContext, createElement, type PropsWithChildren, type ReactElement, useContext } from 'react';

const OmnibusEnabledContext = createContext(true);

export function OmnibusEnabledProvider({ enabled, children }: PropsWithChildren<{ enabled: boolean }>): ReactElement {
    return createElement(OmnibusEnabledContext.Provider, { value: enabled }, children);
}

export function useOmnibusEnabled(): boolean {
    return useContext(OmnibusEnabledContext);
}
